"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import CommonImage from "@/components/common/image/CommonImage";
import { IoChevronDown } from "react-icons/io5";
import InstructorCard from "@/components/common/card/InstructorCard";
import HomePageService from "@/services/api/HomeService";
import { Empty, Spin } from "antd";
import InstructorService from "@/services/api/InsturctorService";

export default function Instructors() {
  const [loading, setLoading] = useState(false);
  const [instructors, setInstructors] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetchInstructors = async (pageNum = 1) => {
    setLoading(true);
    try {
      const response = await InstructorService.getAllInstructors({
        page: pageNum,
      });
      // console.log("response", response);
      const resData = response?.data || [];
      const currentPage = response?.current_page;
      const lastPage = response?.last_page;

      if (pageNum === 1) {
        setInstructors(resData);
      } else {
        setInstructors((prev) => [...prev, ...resData]);
      }

      setHasMore(currentPage < lastPage);
    } catch (error) {
      console.error("Error fetching instructors:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchInstructors(nextPage);
  };

  useEffect(() => {
    fetchInstructors(1);
  }, []);

  return (
    <section
      className="section_padding"
    >
      <div className="container">
        <div className="section_title">
          <h2 className="title">
            <span className="w-8 h-8">
              <CommonImage
                src={"/images/home-page/advisor.avif"}
                className="img-icon"
                alt={"Image"}
              />{" "}
            </span>{" "}
            আমাদের মেন্টর যারা
          </h2>
          <p className="short-des">
            ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের
            গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের মাধ্যমে
            আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 section-content-wrap">
          {loading && instructors.length === 0 ? (
            <div className="col-span-full text-center">
              <Spin />
            </div>
          ) : instructors.length > 0 ? (
            instructors.map((instructor, index) => (
              <InstructorCard key={index} instructor={instructor} />
            ))
            
          ) : (
            <div className="col-span-full text-center">
              <Empty />
            </div>
          )}
        </div>

        {/* see more button */}
        {hasMore && (
          <div className="text-center mt-8">
            <button onClick={handleLoadMore} className="seemore-btn">
              আরো দেখো <IoChevronDown />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
